<app-skeleton [loading]="loading" height="140px">
    <app-source-detail [baseInfo]="baseInfo"
        [capacityPercentData]="capacityPercentData"
        [showPercentBar]="false"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        icon="#infigo-vStore"
        type="vStore"
    >
    </app-source-detail>
</app-skeleton>



